import { env } from "../env";
import { orderType } from "./Constants";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

const trackPurchase = (purchaseData:any) => {
  if(env !== "prod") return;
  window.dataLayer = window.dataLayer || [];
 
  window.dataLayer.push({

    event: "purchase",

    ecommerce: purchaseData

  });

};

const getOrderQuantity = (type:any, orderData:any) => {
  if (!type || !orderData) return 0;

  switch (type) {
    case orderType.puja:
      return 1;

    case orderType.chadhava:
      return orderData?.selectedChadhavaPackage?.length || 0;

    case orderType.prasad:
      return orderData?.selectedPrasadPackage?.length || 0;

    case orderType.chadhavaPackage:
    case orderType.pujaPackage:
      // Checks if packageItems exists, then returns length (works for Array) 
      // or key count (if it is an Object)
      const items = orderData?.pujaDetails?.packageItems;
      if (!items) return 0;
      return Array.isArray(items) ? items.length : Object.keys(items).length;

    default:
      return 0;
  }
};

const getOrderDisplayName = (item:any) => {
  if (!item) return "";

  const specializedTypes = [
    orderType.puja,
    orderType.pujaPackage,
    orderType.chadhavaPackage,
  ];

  let firstPart, secondPart;

  if (specializedTypes.includes(item?.orderType)) {
    firstPart = item?.pujaDetails?.nameKey;
    secondPart = item?.pujaDetails?.pujaNameKey;
  } else {
    firstPart = item?.templeDetails?.nameKey;
    secondPart = item?.orderType;
  }

  return [firstPart, secondPart].filter(Boolean).join(" - ");
};
 

export {
  trackPurchase,
  getOrderQuantity,
  getOrderDisplayName,
}